import * as RequestUtil from "../http_request/RequestUtil.js";

/**
 * Verifies a user's email using a token-based verification link.
 * 
 * @param {string} token - The verification token from the email link
 * @param {string} applicationName - The application name (appkarma, cashkarma)
 * @param {function} callback - Callback(errorInfo, responseInfo)
 */
export const verifyEmail = function(token, applicationName, callback) {
    let params = {};
    params["token"] = token;
    params["data_0"] = applicationName;
    var fullUrl = RequestUtil.createFullUrl("/app_all/browserweb_account_verify", params);
    RequestUtil.requestGET(fullUrl,
        function(errorInfo, respData) {
            if (errorInfo) {
                callback(errorInfo);
            } else {
                let responseInfo = {};
                callback(null, responseInfo);
            }
    });
}
